import React, { createContext, useEffect, useMemo, useState } from "react";
import App from "./App";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import copy from "copy-to-clipboard";
import { ethers } from "ethers";
import { useAccount, useChainId, useChains, useSwitchChain } from "wagmi";
import useEthersProvider from "./Component/hooks/useEthersProvider";
import useEthersSigner from "./Component/hooks/useEthersSigner";
import { chains } from './networkConfig';
import contractdata from './contract.json'

export const ProjectContext = createContext();
const projectId = "add9330b54e1bff01976b4fa3fa25808";

function Projectcontext() {
  const provider = useEthersProvider();
  const signer = useEthersSigner();
  const { isConnected,
    address
  } = useAccount();
//   const address = "0xefaf9edb3323a9d961500d8ad98d35755fcd49c9";
  // console.log("address contexct", address);
  // const { error } = useWeb3ModalError()
  const mainnet = useChains();

  const [selectToken, setselectToken] = useState(false);
  const [maticbalance, setmaticBalance] = useState(0);
  const [balance, setBalance] = useState(0);
  const [Ubalance, setUBalance] = useState(0);
  const [Dbalance, setDBalance] = useState(0);
  const [settings, setsettings] = useState([]);
  const [rate, setrate] = useState(0);
  // start
  const [esigner, setesigner] = useState(null);
  const [dashD, setdashD] = useState(null);
  const [tokenrate, settokenrate] = useState(1);
  const [DefinRate, setDefinRate] = useState(0);
  const [dbbalance, setdbbalance] = useState(0);
  const [Earnig, setEarnig] = useState(0);
  const [Team, setTeam] = useState(0);
  const [dbReward, setdbReward] = useState(0);
  const [DailReawardCap, setDailReawardCap] = useState(0);
  const [x2balance, setx2balance] = useState(0);
  const [dbuser, setdbuser] = useState(null);
  const [dbuserx1, setdbuserx1] = useState(0);
  const [usertnx, setusertnx] = useState(null);
  const [usertnxDate, setusertnxDate] = useState(null);
  const [NextCxDate, setNextCxDate] = useState(null);
  const [account, setaccount] = useState(address);
  const [Defincontract, setDefincontract] = useState(null);
  const [swap_contract, setSwapcontract] = useState(null);
  const [Maincontract, setMaincontract] = useState(null);
  const [Wcontract, setWcontract] = useState(null);
  const [Wcontract2, setWcontract2] = useState(null);
  const [Usdtcontract, setUsdtcontract] = useState(null);
  const [DailyReward, setDailyReward] = useState(null);
  const [CapDailyReward, setCapDailyReward] = useState(null);
  const [DailyRoi, setDailyRoi] = useState(null);
  const [Claimed, setClaimed] = useState(null);
  const [ClaimLimit, setClaimLimit] = useState(null);
  // end
  const [dbuserload, setdbuserload] = useState(false);
  const [stakcontractaddress, setstakcontractaddress] = useState(null);
  const [tokencontract, settokencontract] = useState(null);
  const [tokenhex, settokenhex] = useState(null);
  const [reloadData, setreloadData] = useState(false);
  const [isBsc, setisBsc] = useState(true);
  const chainId = useChainId();
  const [isClassToggled, setIsClassToggled] = useState(false);
  const [showmenu, setshowmenu] = useState(false);
  const [showMenu, setShowMenu] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenToken, setIsOpenToken] = useState(false);
  const [useractivestatus, setuseractivestatus] = useState(false);
  const [wfee, setwfee] = useState(0);

  // const [Refaddress, setRefAddress] = useState();

  const [Refaddress, setRefAddress] = useState(dbuser?.ref_address || ''); // Default to an empty string if not available

  useEffect(() => {
    // Only update Refaddress if it's empty and dbuser has ref_address
    if (!Refaddress && dbuser?.ref_address) {
      setRefAddress(dbuser.ref_address);
    }
  }, [dbuser]); // Only watch dbuser for changes

  const formatAddress = (address) => {
    if (address) {
      return address.substr(0, 6) + "..." + address.substr(-6, 6);
    }
  };
  function reload() {
    setreloadData(!reloadData)
  }

  const toastError = (data) => {
    toast.error(data);
  };
  const toastSuccess = (data) => {
    toast.success(data);
  };
  const toastInfo = (data) => {
    toast(data, {
      // Custom Icon
      icon: "❕",
      // Aria
      ariaProps: {
        role: "status",
        "aria-live": "polite",
      },
    });
  };

  const copyaddress = (address) => {
    copy(address);
    toastSuccess("Copy");
  };

  const getSetting = async () => {
    setsettings(contractdata);
  };
  function formatDateTime(timestamp) {
    // If timestamp is '0' or invalid, return a fallback value
    if (!timestamp) {
      return '-';
    }

    // Create a Date object from the ISO 8601 string
    const date = new Date(timestamp);

    // Check if it's a valid date
    if (isNaN(date)) {
      return 'Invalid Date';
    }

    // Get the date components
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    // Get the time components
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    // Construct the formatted date-time string
    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;

    return formattedDateTime;
  }


  const getSigner = async () => {
    if (!isConnected) return;
    setesigner(signer)
    const balance = await provider.getBalance(account);
    setmaticBalance(Number(ethers.utils.formatUnits(balance, 18)).toFixed(2));
  }
  useEffect(() => {
    if (isConnected && account && provider && signer) {
      getSigner();
    }
  }, [isConnected, account, provider, signer]);

  console.log("settings->", settings);

  const arbProvider = new ethers.providers.JsonRpcProvider("https://arb1.arbitrum.io/rpc");

  const rateContract = useMemo(() => {
    if (!settings?.ratecontract || !Array.isArray(settings?.ratecontract_abi)) {
      console.warn("Rate contract ABI or address not found.");
      return null;
    }
    return new ethers.Contract(settings.ratecontract, settings.ratecontract_abi, arbProvider);
  }, [settings]);

  const fetchTokenRate = async () => {
      if (!rateContract) return;

      try {
        const tokenRate = await rateContract.tokenrate();
        const tRate = Number(ethers.utils.formatUnits(tokenRate, 6)).toFixed(8);
        setDefinRate(tRate); // optionally set the formatted tRate too if needed
      } catch (err) {
        console.error("Failed to fetch token rate:", err);
      }
    };

  const getsmcs = async () => {
    if (!isConnected || !settings.token || esigner === null) return;
    let contract;
    let maincontractwrite;
    let defin_contract;
    let Swap_contract;
    let W_contract;
    let W_contract2;
    try {
      contract = new ethers.Contract(settings.token, settings.token_abi, esigner);
      defin_contract = new ethers.Contract(settings.defin, settings.defin_abi, esigner);
      maincontractwrite = new ethers.Contract(settings.contract, settings.contract_abi, esigner);
      Swap_contract = new ethers.Contract(settings.swap, settings.swap_abi, esigner);
      W_contract = new ethers.Contract(settings?.withdrawalcontract, settings?.withdrawalcontract_abi, esigner);
      W_contract2 = new ethers.Contract(settings?.withdrawalcontract_1, settings?.withdrawalcontract_1_abi, esigner);
        
    await fetchTokenRate();

    } catch (error) {
      console.error("Error initializing contracts:", error);
      return;
    }

    const definfee = await maincontractwrite.withdrawalfee();
    var wfee = Number(ethers.utils.formatUnits(definfee, 18)).toFixed(0)
    setwfee(wfee);

    // Defin Token Rate
    // const definRate = await maincontractwrite.tokenrate();
    // setDefinRate(Number(ethers.utils.formatUnits(definRate, 18)).toFixed(8));
    // Fetch the balance for USDT
    const ubalance = await contract.balanceOf(address);
    const formattedUbalance = Number(ethers.utils.formatUnits(ubalance, 18)).toFixed(2);
    setUBalance(formattedUbalance);
    // Fetch the balance for Defin
    const dbalance = await defin_contract.balanceOf(address);
    const formattedDbalance = Number(ethers.utils.formatUnits(dbalance, 18)).toFixed(2);
    setDBalance(formattedDbalance);

    setMaincontract(maincontractwrite);
    setUsdtcontract(contract);
    setDefincontract(defin_contract);
    setSwapcontract(Swap_contract);
    setWcontract(W_contract);
    setWcontract2(W_contract2);

    try {
      // const balance = await contract.balanceOf(address);
      // setBalance(Number(ethers.utils.formatUnits(balance, 18)).toFixed(2));

      const getUser = await maincontractwrite.users(account);
      console.log("Raw getUser response:", getUser);

      if (!getUser || getUser.length === 0) {
        console.error("No user data found for address:", account);
        return null;
      }
      const userData = {
        ref_address: getUser[0],
        address: getUser[1],
        stake: ethers.utils.formatUnits(getUser[2], 18),
        withdrawal: ethers.utils.formatUnits(getUser[3], 18),
        levelreward: ethers.utils.formatUnits(getUser[4], 18),
        dailyreward: ethers.utils.formatUnits(getUser[5], 18),
        date: ethers.utils.formatUnits(getUser[6], 18),
        packageexpire: getUser[7].toLocaleString(),
        lastpackage: getUser[8],
        status: Number(getUser[10]),
      };

      setdbuser(userData);
      if (userData?.address.toLowerCase() === account?.toLowerCase()) {

        const userlimit = await W_contract2?.userlimit(account);
        var Claimlimit = Number(ethers.utils.formatUnits(userlimit, 18));
        setClaimLimit(Claimlimit);
        
        const nextclaim = await W_contract2?.nextClaimed(account);
        var wTime = nextclaim?.toLocaleString();

        setNextCxDate(wTime);
        console.log("wTime", wTime);
        
        const getUserClaim1 = await W_contract?.users(account);
        console.log("askdfnjkanjkadf-?", ethers.utils.formatUnits(getUserClaim1[3], 18));

        const getUserClaim = await W_contract2?.users(account);
        console.log("askdfnjkanjkadf-?", ethers.utils.formatUnits(getUserClaim[3], 18));

        var TotalClaimed = Number(userData?.withdrawal) + Number(ethers.utils.formatUnits(getUserClaim[3], 18) ? ethers.utils.formatUnits(getUserClaim[3], 18) : 0) + Number(ethers.utils.formatUnits(getUserClaim1[3], 18) ? ethers.utils.formatUnits(getUserClaim1[3], 18) : 0)
        setClaimed(TotalClaimed);
        // User Team
        const getUserTeam = await maincontractwrite.getuserteam(account);
        setTeam(getUserTeam.toString());


        console.log("getUserTeam.toString()", getUserTeam.toString());

        // Get User Tnx
        console.log("TRN-1", userData?.lastpackage);
        const getUserTnx = await maincontractwrite.transactions(userData?.lastpackage);
        console.log("TRN", getUserTnx);

        setusertnx(ethers.utils.formatUnits(getUserTnx[2], 18));
        // setusertnxDate(getUserTnx[8].toLocaleString());


        const x15cap = ethers.utils.formatUnits(getUserTnx[2], 18) * 1.5;
        const currentTimestamp = Math.floor(Date.now() / 1000);

        // User Capping
        const timestamp = Math.floor(Date.now() / 1000);
        console.log("D", timestamp);
        const getUserCap = await maincontractwrite.capping(account, timestamp);
        // const getUserCap = await maincontractwrite.capping(account);


        setuseractivestatus(Number(getUserCap[2].toString()) === Number(1) ? true : false);
        setusertnxDate(getUserCap[3].toLocaleString());
        setCapDailyReward(Number(ethers.utils.formatUnits(getUserCap[0], 18)))

        //Daily Reward
        const getDailyReward = Number(ethers.utils.formatUnits(getUserCap[0], 18)) + Number(userData?.dailyreward);
        setDailyReward(getDailyReward);


        const getDailyRoi = await maincontractwrite.daily_roi();
        setDailyRoi(Number(ethers.utils.formatUnits(getDailyRoi, 18)).toFixed(0));

        // Main balance
        const mainbalance = Number(
          Number(ethers.utils.formatUnits(getUserCap[0], 18)) + Number(userData?.levelreward) + Number(userData?.dailyreward) - Number(userData?.withdrawal) - Number(ethers.utils.formatUnits(getUserClaim[3], 18) ? ethers.utils.formatUnits(getUserClaim[3], 18) : 0) - Number(ethers.utils.formatUnits(getUserClaim1[3], 18) ? ethers.utils.formatUnits(getUserClaim1[3], 18) : 0)
        ).toFixed(2);

        // const mainbalance = Number(
        //   Number(userData?.levelreward) + Number(userData?.dailyreward) - Number(userData?.withdrawal)
        // ).toFixed(2);
        setdbbalance(mainbalance);

        // Total Earning
        const earnig = Number(ethers.utils.formatUnits(getUserCap[0], 18)) + Number(userData?.levelreward) + Number(userData?.dailyreward);
        setEarnig(earnig);

        // console.log("Earning", Number(userData?.levelreward) + Number(userData?.dailyreward));

        // Total Reward
        const totalReward = Number(ethers.utils.formatUnits(getUserCap[0], 18)) + Number(ethers.utils.formatUnits(getUserTnx[4], 18)) + Number(ethers.utils.formatUnits(getUserTnx[5], 18));
        setDailReawardCap(ethers.utils.formatUnits(getUserCap[0], 18));
        setdbReward(totalReward);
        setdbuserx1(x15cap);
      }

      return userData;
    } catch (error) {
      console.error("Error during contract calls or calculations:", error);
    }
  };

  const CheckReffaral = async () => {
    // try {
    //   const getRUser = await Maincontract.users(Refaddress);
    //   if (!getRUser || getRUser.length === 0) {
    //     console.error("No user data found for address:", account);
    //     return null;
    //   }
    //   const userRData = {
    //     ref_address: getRUser[0],
    //     address: getRUser[1],
    //     status: Number(getRUser[10]),
    //   };
    //   // setdbuser(userData);
    //   // console.log("R CHECK C", userRData.address.toLowerCase() === account.toLowerCase(), userRData.address, account);
    //   // User Capping
    //   const getUserCap = await Maincontract.capping(userRData.address);
    //   // console.log("Reffaral getUserCap", getUserCap[3].toLocaleString());
    //   // console.log("Compare date and time", getFormattedDate(getUserCap[3].toLocaleString()));
    //   var checkTimee = getFormattedDate(getUserCap[3].toLocaleString());
    //   var timestamp = Math.floor(Date.now() / 1000);
    //   var checkTimee2 =  getFormattedDate(checkTimee2);

    //   if (checkTimee < checkTimee2) {
    //     toastError("Referral Not Active!");
    //     return { error: "Referral Not Active!", code: 400 };
    //   }
    //   return { success: true }; // If everything is fine, return success
    // } catch (error) {
    //   console.error("Error during contract calls or calculations:", error);
    // }
  };


  function getFormattedDate(timestamp) {
    // Convert timestamp (assuming it is in seconds, hence multiplying by 1000)
    const date = new Date(Number(timestamp) * 1000);

    // Extract components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so we add 1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Format in YYYY-MM-DDTHH:MM:SS format
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }


  useEffect(() => {
    // Optionally, you can also call getSetting() here if needed
    getSetting();

  }, [account, reloadData]);

  // Set up useEffect to trigger on necessary dependencies
  useEffect(() => {
    getsmcs();
  }, [
    isConnected,
    account,
    settings,
    esigner,
    reloadData, useractivestatus
  ]);


  useEffect(() => {
    setaccount(address);
    // if (address) {
    //   localStorage.setItem("isconnected", true);
    // }
  }, [address]);

  useEffect(() => {
    console.log("chainId", chainId);
    if (chainId === mainnet[0].id) {
      setisBsc(true)
    } else {
      setisBsc(false)
    }
  }, [chainId])

  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          // Default options for all toasts
          className: "",
          duration: 3000,
          style: {
            background: "#fff", // Background color for all toasts
            color: "#000", // Text color for all toasts
            fontWeight: "bold", // Example additional style
            borderRadius: "8px", // Rounded corners for the toast
            padding: "16px", // Toast padding
          },
          success: {
            duration: 3000,
            theme: {
              primary: "green", // Green background for success toasts
              secondary: "white", // White text color for success toasts
            },
            style: {
              borderRadius: "25px",
              boxShadow: "0 4px 8px rgba(0, 128, 0, 0.2)", // Add shadow for success toasts
            },
          },
          error: {
            duration: 3000,
            theme: {
              primary: "red", // Red background for error toasts
              secondary: "white", // White text color for error toasts
            },
            style: {
              borderRadius: "25px",
              boxShadow: "0 4px 8px rgba(255, 0, 0, 0.2)", // Add shadow for error toasts
            },
          },
          loading: {
            duration: 3000,
            theme: {
              primary: "blue", // Blue background for loading toasts
              secondary: "white", // White text color for loading toasts
            },
            style: {
              borderRadius: "25px",
              boxShadow: "0 4px 8px rgba(0, 0, 255, 0.2)", // Add shadow for loading toasts
            },
          },
        }}
      />

      <ProjectContext.Provider
        value={{
          settings: settings,
          library: ethers,
          balance,
          maticbalance,
          dbuser, dashD,
          esigner,
          tokenrate,
          account: account ? account.toLowerCase() : account,
          formatAddress,
          toastError,
          toastSuccess,
          dbbalance, dbuserload,
          toastInfo,
          getsmcs,
          ethers,
          rate,
          copyaddress,
          Maincontract, tokencontract, stakcontractaddress, Defincontract, swap_contract,
          formatDateTime, setaccount,
          reload, reloadData, useSwitchChain,
          isClassToggled, setIsClassToggled, showmenu, setshowmenu, showMenu, setShowMenu,
          isBsc, tokenhex, isOpen, setIsOpen, isOpenToken, setIsOpenToken, selectToken, setselectToken, setdbuser, CheckReffaral,
          // For New Project
          x2balance, setx2balance, usertnx, setusertnx, Refaddress, setRefAddress, dbuserx1, dbReward, DailReawardCap, usertnxDate, Earnig, Team, Ubalance, Dbalance, DefinRate,rateContract, Usdtcontract, DailyReward, DailyRoi, CapDailyReward, getFormattedDate, useractivestatus, wfee, Wcontract,Wcontract2, NextCxDate, Claimed, ClaimLimit,
        }}
      >
        <App />
      </ProjectContext.Provider>
    </>
  );
}

export default Projectcontext;